import { MutableRefObject } from 'react';
import { createStrictContext } from 'envoc-strict-context';

export const [ShadowScrollContextProvider, useShadowScrollContext] =
  createStrictContext<MutableRefObject<HTMLDivElement | null>>();
